<template>
<!-- <InputPhone @UpdatePhonePrefix="v=>{this.phonePrefix=v}" @UpdatePhoneNumber="v=>{this.phoneNumber=v}"></InputPhone> -->
<InputText class="phonePrefix w100pct" @InputError="setInputError" :name="'mobile'" :addClass="addClass" v-model="option.phoneNumber" :only="'mobile'" :errorTip="errorTip" :verification="'notEmpty'" :maxLength="46" :placeholder="$t('word658',['手机号'])" :fillText="$t('word658',['手机号'])" @Enter="$emit('Enter')" ref="mobile">
	<!--
	<div class="mobBefore bdSub-right fSub hover-c-main hover-f-main tra-fast_E">
		<span>+{{phonePrefix.active}}</span>
		<Icon :name="'arrow-d'" class="w1x h1x fR" />
	</div>
	 -->
	<Select :list="option.phonePrefix.list" v-model="option.phonePrefix.active"
		:bindActive="option.phonePrefix.active" :keyMap="{text:'countryName',value:'phonePrefix'}"
		:displayFilter="d=>('+'+d.phonePrefix)" :search="{key:'countryName',placeholder:getLanguageStr('phrase674','输入国家/代码')}"
		:styleType="'phonePrefix'"
	></Select>
	<div class="splitLine-y h2x bgSub"></div>
</InputText>
</template>
<script>
import * as lib from '@/util/lib.js';
import {getLanguageStr} from '@/util/language.js';

import InputText from '@/components/common/ui/InputText';
import Select from '@/components/common/ui/Select';

import {apiGetPhonePrefixList, apiGetCountry} from '@/api/base.js';

export default{
	name: '',
	components: {InputText, Select},
	props: {
		phoneNumber: {
			type: [Number, String],
			default: ''
		},
		phonePrefix: {
			type: [Number, String],
			default: ''
		},
		addClass: {
			type: String,
			default: 'sizeL pl7x'
		},
		errorTip: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			option: {
				phoneNumber: this.phoneNumber,
				phonePrefix: {// 电话号码前缀
					active: this.phonePrefix.toString(),
					list: []
				}
			}
		};
	},
	watch: {
		'phonePrefix': function (v) {
			this.option.phonePrefix.active = v;
		},
		'option.phonePrefix.active': {
			handler () {
				this.$emit('UpdatePhonePrefix', this.option.phonePrefix.active);
			},

			immediate: true,
			deep: true
		},
		'option.phoneNumber': function () {
			this.$emit('UpdatePhoneNumber', this.option.phoneNumber);
		},
		phoneNumber: function () {
			this.option.phoneNumber = this.phoneNumber;
		}
	},
	methods: {
		getLanguageStr,
		reset: function () {
			this.$refs.mobile.reset();
		},
		doVerification: function () {
			let out = true;
			out = this.$refs.mobile.doVerification();
			// if(this.phoneNumber==""){
			// 	out=false;
			// }
			return out;
		},
		setInputError: function (error) {
			this.$emit('InputError', error);
		}
	},
	created () {},
	mounted () {
		let $this = this;
		apiGetCountry().then(success => {
			const country = success.code;
			apiGetPhonePrefixList().then(sucs => { // 获取号码前缀列表
				// trace(success,true)
				sucs.map(v => {
					v.countryName += ' +' + v.phonePrefix;// 按展示要求拼接
					if (v.countryCode == country && !$this.option.phonePrefix.active) { // navigator.language.split('-')[1]
						$this.option.phonePrefix.active = v.phonePrefix;// 根据国家设定号码前缀
					}
				});
				if ($this.option.phonePrefix.active == '') $this.option.phonePrefix.active = sucs[0].phonePrefix;
				$this.option.phonePrefix.list = sucs;
				$this.$emit('Success', sucs);
			}, error => {
				$this.$notify(error);
				$this.$emit('Error', error);
			});
		});
	}
};
</script>
<style lang="scss" scoped>
.phonePrefix{
	.splitLine-y{position:absolute;top:.5em;left:6em;}
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/InputPhone.vue